import { GetUsuarioLoggedDtoProps } from "api/DTOs/GetUsuarioLoggedDto"
import { PersonaGetUsuarioLoggedDtoProps } from "api/DTOs/PersonaGetUsuarioLoggedDto"
import Button from "common/components/Button/Button"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import { FormikProps, withFormik } from "formik"
import { TFunction } from "i18next"
import * as Yup from "yup"

interface ExternalProps {
  // eslint-disable-next-line react/no-unused-prop-types
  usuario: GetUsuarioLoggedDtoProps
  // eslint-disable-next-line react/no-unused-prop-types
  updateProfile: (payload: PersonaGetUsuarioLoggedDtoProps) => Promise<void>
  t: TFunction
}

interface FormValues {
  email: string
  nombre: string
  apellidos: string
}

interface ProfileDataProps extends ExternalProps, FormikProps<FormValues> {}

const ProfileData = ({ t, handleSubmit, isSubmitting }: ProfileDataProps) => {
  return (
    <form onSubmit={handleSubmit}>
      <div className='m-0 p-fluid p-formgrid p-grid'>
        <div className='p-0 text-left col-lg-12 w-100'>
          <div className='pl-1 mb-2'>
            <h6>
              <b>{t("profile.profileData.title")}</b>
            </h6>
          </div>

          <div className='p-fluid p-formgrid p-grid'>
            <div className='p-field col-lg-4'>
              <label id='email'>{t("profile.profileData.labelMail")}</label>

              <FormikInputText
                placeholder={`${t("profile.profileData.placeholderMail")}`}
                disabled
                name='email'
                id='email'
                noSpaces
              />
            </div>

            <div className='p-field col-lg-4'>
              <label id='nombre'>{t("profile.profileData.labelName")}</label>

              <FormikInputText
                placeholder={`${t("profile.profileData.placeholderName")}`}
                name='nombre'
                id='nombre'
              />
            </div>

            <div className='p-field col-lg-4'>
              <label id='apellidos'>
                {t("profile.profileData.labelSubName")}
              </label>

              <FormikInputText
                placeholder={`${t("profile.profileData.pladeholderSubName")}`}
                className='w-full'
                name='apellidos'
                id='apellidos'
              />
            </div>
          </div>
        </div>

        <div className='p-0 ml-2 col-lg-2'>
          <Button
            className='!tw-bg-primary'
            loading={isSubmitting}
            type='submit'
          >
            {t("profile.profileData.saveButton")}
          </Button>
        </div>
      </div>
    </form>
  )
}

const validationSchema = (t: TFunction) =>
  Yup.object().shape({
    nombre: Yup.string()
      .ensure()
      .required(`${t("errors.nameEmpty")}`),
    apellidos: Yup.string()
      .ensure()
      .required(`${t("errors.subNameEmpty")}`),
  })

const Validar = withFormik<ExternalProps, FormValues>({
  mapPropsToValues: ({ usuario }) => ({
    email: usuario?.email ?? "",
    nombre: usuario.persona?.nombre ?? "",
    apellidos: usuario.persona?.apellidos ?? "",
  }),
  validationSchema: ({ t }: $TSMigrationFixMe) => validationSchema(t),
  handleSubmit: async (values, { props, setSubmitting }) => {
    setSubmitting(true)

    try {
      await props.updateProfile(values)
      setSubmitting(false)
    } catch (e) {
      setSubmitting(false)
    }
  },
})(ProfileData)

export default Validar
